import React from 'react';

import {EntitlementsPagination} from 'src/modules/entitlements';

import {userEntitlementsStateActions, userEntitlementsStateSelector} from '../slices/user-entitlements-state.slice';

type Props = {
    totalCount: number,
};

export const UserEntitlementsPagination = ({totalCount}: Props) => (
    <EntitlementsPagination
        totalCount={totalCount}
        stateActions={userEntitlementsStateActions}
        stateSelector={userEntitlementsStateSelector}
    />
);
